export const searchNavImages = {
  img1: "searchNav__Acc_Logo_Black_Purple_RGB.png",
};

export const homePageImages = {
  img1: "homePage__abcbanner.png",
  img2: "homePage__learning-journey-new.png",
};

export const apiAutomationPageImages = {
  img1: "apiAutomation__apibanner.png",
  img2: "apiAutomation__api-learning-journey-new.png",
  img3: "APIAutomation-AWARE.png",
  img4: "APIAutomation-Equipped.png",
  img5: "APIAutomation-Competent.png",
};

export const manualtestPageImages = {
  img1: "maual__banner.png",
};
